var AssetBuilderComponent = {
  name: '_Asset_',
  inputs: [{
    name: 'type',
    friendlyName: 'Asset Type',
    type: 'string',
    "enum": ['carousel', 'image'],
    defaultValue: 'image',
    required: true
  }, {
    name: 'autoPlay',
    type: 'boolean',
    defaultValue: true,
    showIf: function showIf(options) {
      return options.get('type') === 'carousel';
    }
  }, {
    name: 'container',
    friendlyName: 'CMS Asset Container',
    type: 'string',
    defaultValue: null,
    required: true,
    helperText: 'Entering a container is required to use this component. If you do not provide an asset for the mobile container, this container will be used.'
  }, {
    name: 'mobileContainer',
    friendlyName: 'CMS Asset Container - Mobile',
    type: 'string',
    defaultValue: null
  }]
};
export default AssetBuilderComponent;